import React from 'react';
import { Sparkles, Phone, Mail, MapPin, Facebook, Home } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section brand-section">
            <div className="footer-logo">
              <img 
                src="/logo-new.png" 
                alt="Aplus Crystal Clean" 
                className="footer-logo-image"
                style={{ height: '78px', width: 'auto', marginBottom: '1rem', objectFit: 'contain' }}
              />
            </div>
            <p className="footer-tagline">
              Professional cleaning services that make your space shine.
            </p>
          </div>

          <div className="footer-section contact-section">
            <h3 className="footer-heading">Contact Us</h3>
            <div className="contact-info">
              <a href="tel:859-724-2341" className="contact-item">
                <Phone size={18} />
                <span>859-724-2341</span>
              </a>
              <a href="mailto:ccofficehomeservice@gmail.com" className="contact-item">
                <Mail size={18} />
                <span>ccofficehomeservice@gmail.com</span>
              </a>
              <div className="contact-item">
                <MapPin size={18} />
                <span>Roseville, CA</span>
              </div>
            </div>
          </div>

          <div className="footer-section social-section">
            <h3 className="footer-heading">Follow Us</h3>
            <div className="social-links">
              <a 
                href="https://www.facebook.com/people/A-Crystal-Clean/61582914721741/" 
                className="social-link" 
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook size={24} />
              </a>
              <a 
                href="https://nextdoor.com/pages/a-crystal-clean-llc-roseville-ca/?is=feed_author" 
                className="social-link" 
                aria-label="Nextdoor"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Home size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © {new Date().getFullYear()} Aplus Crystal Clean LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
